export default "__VITE_ASSET__MMeXA3fr__"